// extracted by mini-css-extract-plugin
export default {"paper":"BotOpportunities_paper__EXpXV","pagination":"BotOpportunities_pagination__l2sIg"};